<template>
    <div>
        <form-control name="credits">	
            <vue-editor name="credits" :editor-toolbar="['link']" style="max-width: 700px" :value="initialText"></vue-editor>
        </form-control>
    </div>
</template>

<script>

export default {
    
    name: "CECredits",
    
    props:{
        items:{
            
        },
    },

    computed:{
        initialText(){
            if(!this.items){
                console.log('no data');
                return '';
            }
            let text = '<p>';

            this.items.forEach( (item) => text += (item.state + ' - ' + item.longDescription + '\n') );

            text += '</p>';
            return text;

            //return '<p>' + this.items.map( (item) => item.state + ' - ' + item.longDescription ).split('\n') + '</p>';
        }
    },

}
</script>

<style scoped>

</style>